import { SHOP_ROUTES } from '../../../config/api-routes';
import instance from '../../../config/instance';

/**
 * Get default shop price
 * This API fetches the default shop pricing information
 * @returns {Promise} - Shop price data
 */
export const getDefaultShopPriceApi = async () => {
    const response = await instance.get(SHOP_ROUTES.GET_DEFAULT_SHOP_PRICE);
    return response.data.data || response.data;
};

/**
 * Get shop details
 * This API fetches the complete shop details
 * @returns {Promise} - Shop details data
 */
export const getShopDetailsApi = async () => {
    const response = await instance.get(SHOP_ROUTES.GET_SHOP_DETAILS);
    return response.data.data || response.data;
};

/**
 * Update shop details
 * This API updates the shop details with new information
 * @param {object} payload - Shop details data to update
 * @returns {Promise} - Updated shop details data
 */
export const updateShopDetailsApi = async (payload) => {
    const response = await instance.put(SHOP_ROUTES.UPDATE_SHOP_DETAILS, payload);
    return response.data.data || response.data;
};
